

import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'

import initializeDayJs from '@/shared/lib/setupDayjsConfig'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { persistor, store } from '../shared/store'
import { AppRouter } from './AppRouter'
import { GlobalThemeProvider } from './providers'
import { GlobalDragDropProvider } from './providers/GlobalDragDropProvider/GlobalDragDropProvider'
import { GlobalDriverProvider } from './providers/GlobalDriverProvider/GlobalDriverProvider'
import { GlobalSubscriptionProvider } from './providers/GlobalSubscriptionProvider/GlobalSubscriptionProvider'
import { GlobalToastProvider } from './providers/GlobalToastProvider/GlobalToastProvider'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 0,
    },
  },
})

export const App: React.FC = () => {
  initializeDayJs()

  return (
    <div style={{ overflowX: 'hidden', width: '100%', height: '100%' }}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <QueryClientProvider client={queryClient}>
            <GlobalThemeProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={'en'}>
                <GlobalDriverProvider>
                  <GlobalDragDropProvider>
                    <GlobalToastProvider>
                      <GlobalSubscriptionProvider>
                        <RouterProvider router={AppRouter()} />
                      </GlobalSubscriptionProvider>
                    </GlobalToastProvider>
                  </GlobalDragDropProvider>
                </GlobalDriverProvider>
              </LocalizationProvider>
            </GlobalThemeProvider>
          </QueryClientProvider>
        </PersistGate>
      </Provider>
    </div>
  )
}

